import React, {Component} from 'react';
import {Button, Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import {toast} from 'react-toastify';
import {isEmpty} from 'lodash';

import loadingGIF from "../../public/assets/images/loading.gif";
import {getUser} from "../../utils/TokenManager";
import ErrorMsg from "../common/ErrorMsg";
import {downloadPDF} from "../common/Constants";
import DailyAttendanceService from "../../services/DailyAttendanceService";


export default class PeriodSelectionModal extends Component {
    
    state = {
        periodList: [],
        staffList: [],
        selectedPeriod: '',
        selectedStaff: 0,
        isLoading: false
    };

    componentDidMount = () => {
        if (this.props.agencyLocation) {
            this.getInitialState();
        }
    };

    getInitialState = async () => {
        try {
            const result = await DailyAttendanceService.getPeriodList();
            if (200 === result.status) {
                let periodList = result.data.map((period) => ({...period}));
                this.setState({periodList});
            }
        } catch (error) {
            toast.error(<ErrorMsg errors={error.response}/>);
        }
        if (this.props.adminDashboard) {
            try {
                const result = await DailyAttendanceService.getStaffList(
                    this.props.agencyLocation
                );
                if (200 === result.status) {
                    let staffList = result.data.user.map((staff) => ({...staff}));
                    this.setState({staffList});
                }
            } catch (error) {
                toast.error(<ErrorMsg errors={error.response}/>);
            }
        } else {
            const userId = getUser().id
            this.setState({selectedStaff: userId});
        }
    };

    periodChangeHandler = (event) => {
        let selectedPeriod = event.currentTarget.value;
        if (selectedPeriod) {
            this.setState({selectedPeriod});
        }
    };

    userChangeHandler = (event) => {
        let selectedStaff = event.currentTarget.value;
        if (selectedStaff > 0) {
            this.setState({selectedStaff});
        }
    };

    toggleModal = () => {
        this.setState({
            selectedStaff: 0,
            selectedPeriod: '',
        }, () => this.props.toggleModal());
    };

    generatePDF = async() => {
        const {selectedStaff, selectedPeriod, periodList} = this.state;
        if (selectedPeriod && selectedStaff > 0 ) {
            this.setState({isLoading: true});
            try {
                let startDate = periodList[selectedPeriod].start_date;
                let endDate = periodList[selectedPeriod].end_date;

                let result = await DailyAttendanceService.getAttendancePDF(
                    selectedStaff, startDate, endDate
                );
                
                if (200 === result.status) {
                    let content = result.data.content;
                    let fileName = result.data.file_name;
                    downloadPDF(content, fileName);
                    this.toggleModal();
                }
            } catch (error) {
                toast.error(<ErrorMsg errors={error.response}/>);
            }
            this.setState({isLoading: false});
        } else {
            toast.error("Please select a specific period and a staff.")
        }
    }

    generatePDFforAllStaff = async() => {
        const {selectedPeriod, periodList} = this.state;
        if (selectedPeriod) {
            this.setState({isLoading: true});
            try {
                let startDate = periodList[selectedPeriod].start_date;
                let endDate = periodList[selectedPeriod].end_date;

                let result = await DailyAttendanceService.getAttendancePDFforAllStaff(
                    this.props.agencyLocation, startDate, endDate
                );
                
                if (200 === result.status) {
                    let content = result.data.content;
                    let fileName = result.data.file_name;
                    downloadPDF(content, fileName);
                    this.toggleModal();
                }
            } catch (error) {
                toast.error(<ErrorMsg errors={error.response}/>);
            }
            this.setState({isLoading: false});
        } else {
            toast.error("Please select a specific period.")
        }
    }
   
    generatePDFforAllStaffSummary = async(name) => {
        const {selectedPeriod, periodList} = this.state;
        if (selectedPeriod) {
            this.setState({isLoading: true});
            try {
                let startDate = periodList[selectedPeriod].start_date;
                let endDate = periodList[selectedPeriod].end_date;
                let result = {};
                if (name == "PDFSummary"){
                     result = await DailyAttendanceService.getTimesheetSummaryPDF(
                        this.props.agencyLocation, startDate, endDate
                    );

                }
                if (200 === result.status) {
                    let content = result.data.content;
                    let fileName = result.data.file_name;
                    downloadPDF(content, fileName);
                    this.toggleModal();
                }
            } catch (error) {
                toast.error(<ErrorMsg errors={error.response}/>);
            }
            this.setState({isLoading: false});
        } else {
            toast.error("Please select a specific period.")
        }
    }


    render() {
        const {
            staffList, periodList, selectedPeriod, selectedStaff, isLoading
        } = this.state;
        let periodListOption = [], staffListOption;

        if (!(isEmpty(periodList))) {
            periodListOption = periodList.map((list, index) =>
                <option key={index} value={index}>{list.period_range}</option>
            );
        }

        if (!(isEmpty(staffList))) {
            staffListOption = staffList.map((list, index) =>
                <option key={index} value={list.id}>{list.full_name}</option>
            );
        }
        
        return (
            <Modal size={"sm"} isOpen={this.props.modal} toggle={this.toggleModal}>
                <ModalHeader toggle={this.toggleModal}>
                    Select Timesheet Period
                </ModalHeader>
                <ModalBody>
                    <div className="row">
                        <div className="col-sm-12">
                            <label className="mb-1">Select Timesheet Period</label>
                            <select name="user_name" className="form-control"
                                    onChange={this.periodChangeHandler}
                                    value={selectedPeriod}>
                                <option value="">Select a period</option>
                                {periodListOption}
                            </select>
                        </div>

                        {this.props.adminDashboard &&
                        this.props.staffname &&
                        <div className="col-sm-12 my-3">
                                <label className="mb-1">Select Staff Name</label>
                                <select name="user_name" className="form-control"
                                    onChange={this.userChangeHandler}
                                    value={selectedStaff}
                                >
                                    <option key="0" value="0">Select a staff</option>
                                    {staffListOption}
                                </select>
                            </div>
                        }
                        {isLoading && 
                            <img src={loadingGIF} alt="Loading..." 
                                width="32" height="32" className="loading-gif"
                            />
                        }
                    </div>
                </ModalBody>
                {this.props.staffname &&
                <ModalFooter>
                    {this.props.adminDashboard &&
                        <Button color="success" onClick={this.generatePDFforAllStaff} 
                            disabled={isLoading}
                        >
                            Print all staff
                        </Button>
                    }
                    <Button color="success" onClick={this.generatePDF} disabled={isLoading}>
                        Print {this.props.adminDashboard ? "selected staff":""}
                    </Button>
                    <Button color="secondary" onClick={this.toggleModal}>Close</Button>
                </ModalFooter>
            }
            {!this.props.staffname &&
                <ModalFooter>
                    {this.props.adminDashboard &&
                        <Button color="success"  onClick={async() =>  {await this.generatePDFforAllStaffSummary("PDFSummary");}} 
                            disabled={isLoading}
                        >
                            Print Summary
                        </Button>
                    }
                </ModalFooter>
            }
            </Modal>

        );
    }
}


// WEBPACK FOOTER //
// ./src/components/daliyAttendance/PeriodSelection.js